//we use this id for create unic name for multiselect
//only used for the ac selection
var radioUnicId = 0

export function inventory_update(id) {

	radioUnicId++
	return `

	<div class="line line-${id} " lineId="${id}" id="inventoryUpdate_form_mt_${radioUnicId}"> 

		<div class="btn-item-info" data-detail='{"click": [
			{"dest":"ripple"},
			{"dest":"inventoryUpdate", "elem":"fullcont", "act":"jumperToPurchase", "lineId":"${id}"}
		]}'></div>

		<div class="row" style="margin-left:24px;">

			<div style="width:71%;">
				<div class="row">

					<div class="c20">
						<div class="textfield textfield-mini textfield-disabled purchase_code">
							<input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
						</div><!-- textfield -->  
					</div><!-- c25 --> 

					<div class="c25">
						<div class="textfield textfield-mini textfield-disabled provider_name">
							<input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
						</div><!-- textfield -->  
					</div><!-- c25 --> 

					<div class="c25">
						<div class="textfield textfield-mini textfield-disabled purchase_date">
							<input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
						</div><!-- textfield -->  
					</div><!-- c25 --> 

					<div class="c25">
						<div class="textfield textfield-mini textfield-disabled item_description">
							<input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
						</div><!-- textfield -->  
					</div><!-- c25 --> 

				</div><!-- row -->
			</div>

			<div style="width:27%;">
				<div class="row">

					<div class="c25">
						<div class="textfield textfield-mini textfield-disabled unit">
							<input autocomplete="off" class="elem" type="text" tabindex="-1" readonly>
						</div><!-- textfield -->  
					</div><!-- c25 --> 

					<div class="c25">
						<div class="textfield textfield-mini qty">
							<input autocomplete="off" class="elem" type="number" step="1" min="0"
							data-detail='{
								"key": [
									{"dest":"textfield", "act":"typing"},
									{"dest":"inventoryUpdate", "elem":"fullcont", "act":"validateQty", "lineId":"${id}"}
								]
							}' >
						</div><!-- textfield -->  
					</div><!-- c25 --> 

					<div class="c33">
						<div class="textfield textfield-cash textfield-mini selling_price">
							<input autocomplete="off" class="elem" type="number" step="0.01" min="0"
							data-detail='{
								"key": [
									{"dest":"textfield", "act":"typing"},
									{"dest":"inventoryUpdate", "elem":"fullcont", "act":"validateSellingPrice", "lineId":"${id}"}
								]
							}' >
						</div><!-- textfield -->  
					</div><!-- c25 --> 

				</div><!-- row -->

			</div>

		</div><!-- row -->

	</div><!-- line -->  
	`
}
